import { DateTime } from 'luxon';
import React from 'react';

const Rodape = (): React.ReactElement => (
  <div className="bg-dark text-white fw-lighter p-4 animate__animated animate__fadeIn">
    Copyright {DateTime.now().year} - Estude+
  </div>
);

export default Rodape;
